import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as modalActions } from '../../reducers/modal.reducer';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import FaqAdd from './FaqAdd.modal';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
var Faq = function Faq() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    app = _useParams.app;
  var dispatch = useDispatch();
  var faq = useSelector(function (s) {
    return s.ppc.faq || {};
  });
  useEffect(function () {
    dispatch({
      type: ppcActions.faq,
      payload: {}
    });
  }, []);
  var columns = {
    id: {
      title: '_id',
      visible: false
    },
    slot: {
      title: 'slot',
      visible: false
    },
    q: {
      title: 'Question',
      onClick: function onClick(_ref) {
        var row = _ref.row;
        return navigate("/".concat(app, "/faq/").concat(row._id));
      }
    }
  };
  var data = Object.values(faq).filter(function (x) {
    return !x.archived && x.clientApp === app;
  }).map(function (x) {
    return {
      _id: x._id,
      q: x.q,
      slot: x.slot
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "FAQ",
    button: {
      label: 'Add',
      type: 'add',
      permission: "edit-".concat(app, "-faq"),
      onClick: function onClick() {
        dispatch({
          type: modalActions.add,
          payload: {
            component: /*#__PURE__*/React.createElement(FaqAdd, {
              app: app
            })
          }
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: data,
    sort: {
      by: 'slot'
    }
  }))));
};
export default Faq;